import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FaArrowRight, FaCheckCircle } from 'react-icons/fa';
import Navbar from '../components/Navbar';
import ContactActions from '../components/ContactActions';
import Contact from '../components/Contact';
import GoogleReviews from '../components/GoogleReviews';
import Footer from '../components/Footer';
import FloatingContactWidget from '../components/FloatingContactWidget';
import servicePages from '../data/servicePages';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';

const ServiceLandingPage = ({ fixedSlug }) => {
  const { '*': routeSlug } = useParams();
  const slug = fixedSlug || routeSlug;
  const service = servicePages.find((item) => item.slug === slug);
  const { language } = useLanguage();
  const { isDark } = useTheme();

  useEffect(() => {
    if (!service) return;
    const previous = document.title;
    document.title = `${language === 'es' ? service.esTitle : service.title} | NJ Design & Print`;
    return () => { document.title = previous; };
  }, [service, language]);

  if (!service) return null;
  const es = language === 'es';
  const title = es ? service.esTitle : service.title;
  const eyebrow = es ? service.esEyebrow : service.eyebrow;
  const intro = es ? service.esIntro : service.intro;
  const bullets = es ? service.esBullets : service.bullets;

  return <div className={`min-h-screen ${isDark ? 'bg-gray-950' : 'bg-white'}`}>
    <Navbar />
    <main>
      <section className="bg-black pt-28 pb-10 px-4 m-0 overflow-hidden">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] items-center gap-8 lg:gap-12">
          <div className="py-4 lg:py-10">
            <p className="text-atlantis font-black tracking-widest text-sm mb-4">{eyebrow}</p>
            <h1 className="text-white text-4xl sm:text-6xl font-black leading-tight mb-6">{title}</h1>
            <p className="text-gray-100 text-xl leading-relaxed mb-8">{intro}</p>
            <Link to="/contact" className="inline-flex items-center gap-3 rounded-full bg-gradient-to-r from-atlantis to-green-yellow-primary px-8 py-4 text-black font-black">{es ? 'Solicitar cotización gratis' : 'Get a free quote'} <FaArrowRight /></Link>
          </div>
          <div className="relative flex items-center justify-center min-h-[280px] sm:min-h-[420px] lg:min-h-[560px] rounded-3xl overflow-hidden bg-gray-950 border border-white/10 shadow-2xl">
            <img src={service.image} alt={title} className="block max-h-[640px] h-auto w-auto max-w-full object-contain opacity-100" />
          </div>
        </div>
      </section>
      <ContactActions />
      <section className={`py-16 px-4 m-0 ${isDark ? 'bg-gray-950' : 'bg-white'}`}>
        <div className="max-w-5xl mx-auto grid md:grid-cols-3 gap-5">
          {bullets.map((bullet) => <div key={bullet} className={`rounded-2xl border p-6 ${isDark ? 'border-gray-700 bg-gray-800 text-white' : 'border-gray-200 bg-gray-50 text-gray-800'}`}><FaCheckCircle className="text-atlantis text-2xl mb-3" /><p className="font-bold">{bullet}</p></div>)}
        </div>
      </section>
      <GoogleReviews />
      <Contact />
    </main>
    <Footer /><FloatingContactWidget />
  </div>;
};

export default ServiceLandingPage;
